import axios from 'axios';
import { supabase } from '../context/SupabaseClient';
// NOTE: this is for all non admin api calls. Admin calls in src/pages/admin/Dashboard.js still use fetch with the secret header for simplicity, but this can be refactored to use this client as well if desired.
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
const ADMIN_SECRET = process.env.REACT_APP_ADMIN_SECRET || 'defaultsecret';

const api = axios.create({
  baseURL: API_BASE_URL + '/functions/v1', 
  headers: {
    'Content-Type': 'application/json',
    'x-admin-secret': ADMIN_SECRET  // Add admin secret to headers for all requests from this client
  }
});

// This interceptor pulls the token dynamically for EVERY request
api.interceptors.request.use(async (config) => {
  const { data: { session } } = await supabase.auth.getSession();
  
  if (session?.access_token) {
    config.headers.Authorization = `Bearer ${session.access_token}`;
  }
  
  return config;
}, (error) => Promise.reject(error));

// Create User (Admin API)
export const createUser = async (uuid, phone, email) => {
  const response = await api.post('/create-user', {
    uuid,
    phone,
    email
  });  
  return response.data;
};
